import useEmblaCarousel from 'embla-carousel-react';
import { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { EmblaCarouselType } from 'embla-carousel';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ibow2_proto_PortalOfficeHospitalListingImage } from '@/init/swagger';

type LogicProps = {
  images?: ibow2_proto_PortalOfficeHospitalListingImage;
};

export const useLogic = ({ images }: LogicProps) => {
  const [emblaRef, emblaApi] = useEmblaCarousel();
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(1);
  const scrollPrev = useCallback(() => {
    if (emblaApi) {
      emblaApi.scrollPrev();
    }
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) {
      emblaApi.scrollNext();
    }
  }, [emblaApi]);

  const selectEvent = useCallback((emblaApi: EmblaCarouselType) => {
    setCanScrollNext(emblaApi.canScrollNext());
    setCanScrollPrev(emblaApi.canScrollPrev());
    setCurrentSlide(emblaApi.selectedScrollSnap() + 1);
  }, []);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const buttonSize: 'small' | 'medium' = matches ? 'small' : 'medium';
  const captionTextVariant:
    | 'JP/Body/s/Regular/Normal'
    | 'JP/Body/m/Regular/Normal' = matches
    ? 'JP/Body/s/Regular/Normal'
    : 'JP/Body/m/Regular/Normal';

  const imageUrlList = [
    images?.image1_url,
    images?.image2_url,
    images?.image3_url,
    images?.image4_url,
    images?.image5_url,
  ].filter((url): url is string => !!url);

  useEffect(() => {
    if (emblaApi) emblaApi.on('select', selectEvent);
  }, [emblaApi, selectEvent]);

  return {
    emblaRef,
    scrollPrev,
    scrollNext,
    canScrollPrev,
    canScrollNext,
    currentSlide,
    buttonSize,
    captionTextVariant,
    imageUrlList,
  };
};
